/* pers-info-galeria.js — „Dodatkowe informacje” jako karty pod galerią (zadanie 36).

   Przenosi WŁASNY węzeł motywu (.additional__information__wrapper) w obrębie
   #main-product: spod tytułu pod zdjęcia. Treść, ikony i dymki „i” zostają te same.
   Nic nie zapisujemy w formularzu, nie dotykamy kalkulatora ani przycisku.

   Węzeł jest markupem serwerowym — przy `defer` już istnieje, obserwator zbędny.
   Brak galerii albo bloku = nic się nie dzieje (lista zostaje tam, gdzie była).
*/
(function () {
  'use strict';
  var blok = document.querySelector('#main-product .additional__information__wrapper');
  var galeria = document.querySelector('#main-product .product__media-wrapper');
  if (!blok || !galeria) return;
  // Pierwszy element listy bywa pusty (motyw renderuje blok bez treści) —
  // jako karta byłby pustym prostokątem.
  var pozycje = blok.querySelectorAll('.additional__information');
  for (var i = 0; i < pozycje.length; i++) {
    if (!pozycje[i].textContent.replace(/\s+/g, '')) pozycje[i].classList.add('pers-info-pusta');
  }
  blok.classList.add('pers-info-karty');
  galeria.appendChild(blok);
})();
